// hooks/usePlanAware.ts
import { useCallback } from 'react';
import { useDispatch } from '../store/hooks';
import { showUpgradeModal } from '../store/slices/ui.slice';

export function usePlanAware<T extends (...args: any[]) => Promise<any>>(
  fn: T,
): T {
  const dispatch = useDispatch();
  return useCallback(
    async (...args: Parameters<T>) => {
      try {
        return await fn(...args);
      } catch (err: any) {
        let errBody: any;
        if (typeof err?.response?.json === 'function') {
          errBody = await err.response.json();
        } else {
          errBody = err?.response?.data ?? err?.body ?? err;
        }

        const code = errBody?.code;
        const requiredPlan = errBody?.requiredPlan;
        if (code === 'PLAN_REQUIRED' && requiredPlan === 'Business') {
          console.log('Need business plan');
          dispatch(showUpgradeModal());
        }
        throw err;
      }
    },
    [dispatch, fn],
  ) as T;
}
